var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup48320(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117.573,
    height: 117.575,
    viewBox: "0 0 117.573 117.575",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48320",
    "data-name": "Group 48320",
    transform: "translate(-2389.349 -291.793)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48318",
    "data-name": "Group 48318",
    transform: "translate(2389.349 291.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38965",
    "data-name": "Path 38965",
    d: "M2389.353,351.261a58.787,58.787,0,0,1,91.48-49.535l3.344-3.389a1.72,1.72,0,0,1,2.883.751l5.846,21.247a1.719,1.719,0,0,1-2.093,2.119l-21.323-5.561a1.725,1.725,0,0,1-.791-2.877l3.766-3.822a46.96,46.96,0,1,0,22.8,40.675,1.9,1.9,0,0,1,1.7-1.914l8.215-.095a1.689,1.689,0,0,1,1.168.645l.067.068a2.232,2.232,0,0,1,.509,1.444,58.787,58.787,0,0,1-117.569.244Zm102.341-30.475a.44.44,0,0,0-.016-.113l-5.846-21.247a.447.447,0,0,0-.75-.195l-4.088,4.144-.439-.3a57.472,57.472,0,1,0,25.094,47.934h0a1.053,1.053,0,0,0-.141-.54l-.071-.072a2.1,2.1,0,0,0-.291-.263l-8.17.095c-.175,0-.436.347-.439.654a48.425,48.425,0,1,1-22.721-41.35l.671.421-4.882,4.956a.451.451,0,0,0,.2.752l21.324,5.561a.446.446,0,0,0,.56-.437Z",
    transform: "translate(-2389.349 -291.793)",
    fill: "#53b1ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48319",
    "data-name": "Group 48319",
    transform: "translate(2413.172 337.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38966",
    "data-name": "Path 38966",
    d: "M2482.911,463.471h-16.939v-3.564l6.083-6.149q2.7-2.767,3.531-3.837a8.455,8.455,0,0,0,1.193-1.981,5.05,5.05,0,0,0,.365-1.89,2.754,2.754,0,0,0-.8-2.171,3.119,3.119,0,0,0-2.146-.712,6.172,6.172,0,0,0-2.735.646,14.124,14.124,0,0,0-2.768,1.84l-2.784-3.3a18.2,18.2,0,0,1,2.967-2.155,10.89,10.89,0,0,1,2.569-.97,13.178,13.178,0,0,1,3.116-.34,9.22,9.22,0,0,1,4.011.829,6.4,6.4,0,0,1,2.7,2.32,6.168,6.168,0,0,1,.961,3.415,8.36,8.36,0,0,1-.589,3.141,12.06,12.06,0,0,1-1.823,3.008,44.6,44.6,0,0,1-4.351,4.392l-3.116,2.934v.232h10.558Z",
    transform: "translate(-2465.906 -438.891)",
    fill: "#53b1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38967",
    "data-name": "Path 38967",
    d: "M2544.146,459.22h-2.917v5.022h-5.005V459.22h-10.342v-3.564L2536.5,440.01h4.724v15.232h2.917Zm-7.922-3.978v-4.11q0-1.028.083-2.984t.133-2.271h-.133a18.44,18.44,0,0,1-1.475,2.652l-4.442,6.713Z",
    transform: "translate(-2507.218 -439.662)",
    fill: "#53b1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38968",
    "data-name": "Path 38968",
    d: "M2600.65,440.01l-9.033,24.232h-4.591l9.033-24.232Z",
    transform: "translate(-2549.336 -439.662)",
    fill: "#53b1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38969",
    "data-name": "Path 38969",
    d: "M2637.122,464.315l9.1-19.889h-11.95v-4.31h17.386v3.215l-9.166,20.983Z",
    transform: "translate(-2581.879 -439.735)",
    fill: "#53b1ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup48320);
export default __webpack_public_path__ + "static/media/Group 48320.54f5074e426274df2e13bd5e82a11fb8.svg";
export { ForwardRef as ReactComponent };